export const getUsersFrag = `
    canEdit
    id
    titleBeforeName
    name
    surname
    titleAfterName
    email
    image
    active
    role {
        name
    }
    employments {
        employmentTypeName
        contract
        workloadSize
        scopeOfWork
        serviceId
    }
`;
